import BusinessIcon from '@mui/icons-material/Business';
import { Chip, ChipProps, Tooltip } from '@mui/material';
import React from 'react';
import { useCompany } from '../../../contexts/CompanyContext';

interface CompanyBadgeProps extends Omit<ChipProps, 'label'> {
  showIcon?: boolean;
  maxLength?: number;
}

const CompanyBadge: React.FC<CompanyBadgeProps> = ({
  showIcon = true,
  maxLength = 20,
  ...chipProps
}) => {
  const { currentCompanyName } = useCompany();
  
  if (!currentCompanyName) {
    return null;
  }
  
  // Truncate company name if it's too long
  const displayName = 
    currentCompanyName.length > maxLength
      ? `${currentCompanyName.substring(0, maxLength)}...`
      : currentCompanyName;
  
  return (
    <Tooltip title={currentCompanyName} arrow>
      <Chip
        icon={showIcon ? <BusinessIcon /> : undefined}
        label={displayName}
        size="small"
        color="primary"
        variant="outlined"
        {...chipProps}
      />
    </Tooltip>
  );
};

export default CompanyBadge;